module.exports = __webpack_public_path__ + "static/media/west_brom.6f4dabf1.png";